import { component, computed } from 'knockout-decorators'
import { marked } from 'marked'

import source from './template.html?raw'

import { CartState } from '../state'

import './styles.css'

@component('cart-terms', source)
export class CartTerms {
  private cartState: CartState = CartState.get()
  private renderer: marked.Renderer = new marked.Renderer()

  private readonly defaultTerms: string[] = [
    'Elfogadom, hogy a(z) TIXA Hungary Kft. (5600 Békéscsaba, Dobozi út 58.) által a(z) www.tixa.hu, felhasználói adatbázisában tárolt alábbi személyes adataim átadásra kerüljenek az OTP Mobil Kft. (1093 Budapest, Közraktár u. 30-32.), mint adatkezelő részére. A továbbított adatok köre: felhasználónév, vezetéknév, keresztnév, ország, telefonszám, e-mail cím.',
    'Az adattovábbítás célja: a felhasználók részére történő ügyfélszolgálati segítségnyújtás, a Tranzakciók visszaigazolása és a felhasználók védelme érdekében végzett fraud-monitoring.',
    'Az alábbi gomb megnyomásával elfogadom a www.tixa.hu Általános Szerződési Feltételeit. Az ÁSZF itt olvasható: www.tixa.hu/aszf',
  ]

  constructor() {
    const linkRenderer = this.renderer.link
    this.renderer.link = (href, title, text) => {
      const htmlresult = linkRenderer.call(this.renderer, href, title, text)
      return htmlresult.replace(/^<a /, '<a target="_blank" rel="nofollow" ')
    }
    this.initializeEventListeners()
  }

  @computed get markedTerms(): string {
    const terms = this.cartState.content?.terms || this.defaultTerms
    return marked.parse(terms.join('\r\n\r\n'), { renderer: this.renderer })
  }

  @computed get extraTerms(): {
    id: string
    checkbox: string
    content: string
  }[] {
    const terms = this.cartState.content?.extraTerms || []

    return terms.map((extraTerm, index) => {
      return {
        checkbox: extraTerm.checkbox,
        content: marked.parse(extraTerm.content, { renderer: this.renderer }),
        id: `extra-term-${index}`,
      }
    })
  }

  private initializeEventListeners() {
    const formEl = CartState.get().formElement

    if (!formEl) {
      return
    }

    const termAcceptCheckbox = formEl.querySelector('#termAcceptCheckbox')

    termAcceptCheckbox?.addEventListener('change', this.removeErrorClass)
  }

  private removeErrorClass(event: Event) {
    const target = event.target as HTMLInputElement
    target.classList.remove('is-invalid')
    const inputId = target.id

    const formEl = CartState.get().formElement

    if (!formEl) {
      return
    }

    const errorMessageElement = formEl.querySelector(
      `.error-message[data-for="${inputId}"]`
    ) as HTMLElement

    if (errorMessageElement) {
      errorMessageElement.classList.remove('visible')
    }
  }
}
